<template>
  <div>
    <div class="my-4 p-4 bg-white shadow sm:rounded-t-md flex items-center gap-x-4 justify-between">
      <FormField
        id="keywords"
        name="keywords"
        placeholder="Chercher nom, prénom ou email du client"
        v-model="keywords"
        style="min-width: 350px"
      >
        <template #prependIcon>
          <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </template>
      </FormField>
    </div>
    <Table :columns="columns" :data="formattedData" :isLoading="isLoading" :noDataMsg="noDataMsg">
      <template #paymentErrorMessage="{ row }">
        {{ row.paymentErrorMessage }}
      </template>
    </Table>
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { Pagination, Table, FormField } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";
import { SearchIcon } from "@heroicons/vue/solid";
import { isAdminRoute } from "@estaly/ui/src/utils/route";

export default {
  components: { Pagination, Table, FormField, SearchIcon },
  props: {
    status: {
      type: String,
      default: null,
    },
    noDataMsg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentPage: 1,
      keywords: null,
    };
  },
  computed: {
    isAdminRoute,
    ...mapGetters("store", ["selectedStoreId"]),
    ...mapGetters("leads", ["getIndex", "isLoading"]),
    leads() {
      return this.getIndex.leads || [];
    },
    totalCount() {
      return this.getIndex.page?.totalCount || 0;
    },
    totalPages() {
      return this.getIndex.page?.totalPages || 0;
    },
    formattedData() {
      return this.leads.map((lead) => ({
        customerFullName: `${lead.customer.firstName} ${lead.customer.lastName}`,
        customerEmail: lead.customer.email,
        storeSalesChannel: lead.store?.salesChannel,
        ...lead,
      }));
    },
    columns() {
      const res = [
        { label: this.$t("LeadsList.Date"), field: "purchaseDate" },
        { label: this.$t("LeadsList.Client"), field: "customerFullName" },
        { label: this.$t("LeadsList.Email"), field: "customerEmail" },
        { label: this.$t("LeadsList.Category"), field: "categoryLabel" },
      ];
      if (this.isAdminRoute) {
        res.unshift({
          label: this.$t("LeadsList.Store"),
          field: "storeSalesChannel",
        });
      }
      return res;
    },
  },
  watch: {
    keywords() {
      this.currentPage = 1;
      this.getLeads();
    },
  },
  created() {
    this.getLeads();
  },
  methods: {
    ...mapActions("leads", ["fetchIndex"]),
    handleChangePage(page) {
      this.currentPage = page;
      this.getLeads();
    },
    async getLeads() {
      const params = {
        page: this.currentPage,
        type: ["lead"],
        status: [this.status],
        keywords: this.keywords,
      };
      if (this.selectedStoreId) params.store = [this.selectedStoreId];
      if (this.isAdminRoute) params.includes = ["store"];
      await this.fetchIndex(params);
    },
  },
};
</script>
